import type { CustomerDetailFields } from "../types";

/** Extended dossier fields keyed by tenant customer ID (TNT-…). */
export const MOCK_CUSTOMER_DETAILS: Record<string, CustomerDetailFields> = {
  "TNT-20260515-7K9X": {
    detailLifecycleStatus: "ACTIVE",
    breadcrumbLabel: "Acme Financial Services",
    orgLogo: null,
    industry: "Banking & financial services",
    hq: "India · IST",
    createdLabel: "15 May 2026 by R Sreenivas",
    accountManager: "R Sreenivas",
    endpointsMonitored: 237,
    compliancePosturePercent: 62,
    complianceFrameworksLabel: "ISO 27001, PCI DSS, GDPR, DPDP, CCPA",
    monitoringCadence: "Weekly · Sun 02:00 IST",
    nextScanLabel: "Next scheduled scan in 4 d 17 h",
    organisation: {
      legalEntity: "Acme Financial Services Pvt Ltd",
      tradeName: "Acme Finance",
      primaryWebsite: "https://www.acmefinancial.com",
      companySize: "251 – 1,000 employees",
      planAndSeats: "Pro · 500 endpoint seats · 50 vendor seats",
      contract: "15 May 2026 → 14 May 2027",
    },
    primaryUser: {
      name: "Priya Sharma",
      email: "priya.sharma@acmefinancial.com",
      role: "Organization Admin",
      roleTitle: "Head of Information Security",
      phone: "+91 98XXX XXXXX",
      firstLogin: "15 May 2026 17:08 IST",
    },
    welcomeLink: {
      status: "Consumed",
      statusTone: "ok",
      issued: "15 May 14:32 IST · by R Sreenivas",
      boundTo: "priya.sharma@acmefinancial.com",
      consumedAt: "15 May 17:08 IST",
      validitySelected: "30 days",
      emailSent: true,
    },
    recentActivity: [
      {
        when: "15 May 17:08",
        actor: "Priya Sharma",
        event: "auth.first_login",
        detail: "Welcome token consumed; routed to CL-3",
      },
      {
        when: "15 May 14:32",
        actor: "System",
        event: "email.sent",
        detail:
          "Welcome email · DKIM signed · to ravi.sreenivas@netshieldtech.com",
      },
      {
        when: "15 May 14:32",
        actor: "System",
        event: "welcome_link.issued",
        detail: "30-day validity · bound to priya.sharma@acmefinancial.com",
      },
      {
        when: "15 May 14:32",
        actor: "R Sreenivas",
        event: "customer.created",
        detail: "via wizard NS-3 → NS-5",
      },
      {
        when: "15 May 14:30",
        actor: "R Sreenivas",
        event: "auth.otp_verified",
        detail: "admin sign-in step 2",
      },
    ],
  },
};
